export const TerminosCondiciones = ({ id, value, className, disabled, setValue, terminos }) => {

    return(
        <div className={className} id={'cont-'+ id}>
            <div class="form-check ps-0">
                <input class="form-check-input cursor-pointer formTerminos" type="checkbox" id={id} value={value} 
                onChange={() => setValue(!value)} disabled={disabled} />
                <label class="form-check-label letraDatos cursor-pointer" for={id}>
                    Acepto los <a className='terminosCondiciones fw-bolder' href={terminos} target="_blank">Términos y Condiciones</a>
                </label>
            </div>
        </div>
    )
}